import * as _ from 'lodash';
import { Formatter, FormatterEx } from 'slickgrid';
import { createElementText, assertNonNullish } from '../helpers';

export interface CellClassFormatterOptions {
  className?: string;
  options?: Dictionary<any>;
  optionsSource?: 'inputValue' | 'fieldValue';
  value?: Function;
}

export function cellclass<T>(opts: CellClassFormatterOptions): Formatter<T> {
  if (!opts) {
    throw new TypeError('Options is required.');
  }

  const options = opts.options,
    className = opts.className;

  const valueResolver = opts.value;

  const cellclassFormatter: FormatterEx<T> = (
    row,
    cell,
    value,
    columnDef,
    data,
  ) => {
    if (value == null) {
      return '';
    }

    if (valueResolver) {
      const cls_values: string[] = [];
      const values = valueResolver(data);

      if (_.isString(values)) {
        cls_values.push(values);
      } else if (_.isObject(values)) {
        _.chain(values)
          .each((v, k) => {
            if (v && k) {
              cls_values.push(k);
            }
          })
          .value();
      }

      if (cls_values.length) {
        return {
          text: value,
          addClasses: cls_values.join(' '),
        };
      }
    }

    if (options) {
      const field = columnDef.field;
      assertNonNullish(field, 'ColumnDefinition.field must have a value.');

      const cls =
        options[
          opts.optionsSource === 'fieldValue' ? data[_.toString(field)] : value
        ];

      if (cls) {
        return {
          text: value,
          addClasses: cls + (className ? ` ${className}` : ''),
        };
      }
    }

    return value;
  };

  cellclassFormatter.exportRawData = true;

  return cellclassFormatter;
}
